<div class="offline-bar-wrapper">
	<div *ngIf="isDisplaying$ | async" class="offline-bar">
		<ng-container *ngIf="status$ | async as status">
			<div class="offline-bar-icon-wrapper">
				<img draggable="false" class="offline-bar-icon" [src]="status.icon" />
			</div>
			<span class="offline-bar-text">
				{{ status.text }}
			</span>
			<div class="offline-bar-action-wrapper">
				<div (click)="action(status.action)" class="offline-bar-action">
					<img draggable="false" [src]="status.actionIcon" />
				</div>
			</div>
		</ng-container>
	</div>

	<!--
  Preload images before socket disconnects
  -->
	<img class="offline-preload" [src]="'./assets/Disconnected (Blue-Gray).svg' | resolveAsset" display="none" />
	<img class="offline-preload" [src]="'./assets/Cancel (Blue-Gray).svg' | resolveAsset" display="none" />
	<img class="offline-preload" [src]="'./assets/Connected (Jade).svg' | resolveAsset" display="none" />
	<img class="offline-preload" [src]="'./assets/Refresh (Jade).svg' | resolveAsset" display="none" />
</div>
